import { render, staticRenderFns } from "./RightDrawer.vue?vue&type=template&id=7235c5a8&scoped=true&"
import script from "./RightDrawer.vue?vue&type=script&lang=js&"
export * from "./RightDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7235c5a8",
  null
  
)

export default component.exports